import { FC } from 'react';
import { Stack, Tooltip } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const DoubleActionButtonGroup: FC<
  React.PropsWithChildren<DoubleActionButtonGroupProps>
> = props => {
  const {
    onSecondaryClick,
    onPrimaryClick,
    isPrimaryLoading,
    isSecondaryLoading,
    secondaryButtonActionLabel,
    secondaryButtonActionTooltip,
    secondaryButtonActionColor,
    primaryButtonActionLabel,
    primaryButtonActionTooltip,
    primaryButtonActionColor,
    isPrimaryActionDisabled,
    isSecondaryActionDisabled,
  } = props;

  return (
    <Stack gap={2} width='100%' justifyContent='flex-end' direction='row'>
      <Tooltip arrow title={secondaryButtonActionTooltip}>
        <span>
          <LoadingButton
            loading={isSecondaryLoading}
            size='medium'
            variant='contained'
            color={secondaryButtonActionColor}
            disabled={isSecondaryActionDisabled}
            onClick={onSecondaryClick}>
            {secondaryButtonActionLabel}
          </LoadingButton>
        </span>
      </Tooltip>
      <Tooltip arrow title={primaryButtonActionTooltip}>
        <span>
          <LoadingButton
            loading={isPrimaryLoading}
            size='medium'
            variant='contained'
            color={primaryButtonActionColor}
            disabled={isPrimaryActionDisabled}
            onClick={onPrimaryClick}>
            {primaryButtonActionLabel}
          </LoadingButton>
        </span>
      </Tooltip>
    </Stack>
  );
};

interface DoubleActionButtonGroupProps {
  onSecondaryClick: () => void;
  onPrimaryClick: () => void;
  isPrimaryLoading: boolean;
  isSecondaryLoading: boolean;
  secondaryButtonActionLabel: string;
  secondaryButtonActionTooltip: string;
  secondaryButtonActionColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
  primaryButtonActionLabel: string;
  primaryButtonActionTooltip: string;
  primaryButtonActionColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
  isSecondaryActionDisabled: boolean;
  isPrimaryActionDisabled: boolean;
}

export default DoubleActionButtonGroup;
